import {db} from '../firebase'
import router from '../router'
import Vue from 'vue'

export default {
    namespaced: true,
    state:{
    },
    mutations:{
    },
    actions:{
        async getSchool(){
            const school = await db.collection('school').doc('data').get()
            return school.data()
        },
        async doUpdate(context, {description}){
            try{
                const schoolRef = await db.collection('school').doc('data')
                console.log(description)
                schoolRef.update({
                    description
                })

                Vue.$toast.success('La escuela fue editada')
                router.push({name: 'Dashboard'})
            }catch(error){
                Vue.$toast.error('Hubo un problema al editar la escuela, intenta nuevamente más tarde')
                console.error(error)
            }
        }
    }
}